<template>
  <section>
    <BankList :query="query" />
  </section>
</template>
<script>
import BankList from '@/components/basic/BankList.vue'

export default {
  name: 'Banks',
  components: { BankList },
  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
